module.exports = __webpack_public_path__ + "img/beer_id-34.e863c179.png";